import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TrailBalanceService {

    constructor(private http: HttpClient, private configService: ConfigurationService) { }
  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API
  SaveTrailbalance(AccountingList: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/TrailBalance/SaveTrailbalance`;
    return this.http.post<any>(url, AccountingList);
  }
  GetTrailbalancetemplate(UserId: any, CentralUserId: any, charityId: any, PeriodID: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/TrailBalance/GetTrailbalancetemplate`;
    const params = new HttpParams()
      .set('UserId', UserId.toString())
      .set('CentralUserId', CentralUserId.toString())
      .set('charityId', charityId.toString())
      .set('PeriodID', PeriodID.toString());

    return this.http.get(url, { params });
  }
  GetTrailBalanceReportDetails(UserId: any, CentralUserId: any, charityId: any, PeriodID: any) {
    CentralUserId = +CentralUserId;
    UserId = +UserId;
    const url = `${this.apiUrl}/TrailBalance/GetTrailbalanceRunReportDetails?UserId=${UserId}&CentralUserId=${CentralUserId}&charityId=${charityId}&PeriodID=${PeriodID}`;
    return this.http.get(url);
  }
  isTrailBalancesaved(PeriodID: any) {
    const url = `${this.apiUrl}/TrailBalance/isTrailBalancesaved?PeriodID=${PeriodID}`;
    return this.http.get(url);
  }
}
